var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "task-list" },
    [
      _c(
        "navigation-bar",
        [
          _c("navigation-link", {
            attrs: {
              icon: "icon_eta",
              label: "Pollers",
              to: {
                name: "task-list/pollers",
                params: { clusterName: _vm.clusterName }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "feature-flag",
            { attrs: { display: "inline", name: "taskListPartition" } },
            [
              _c("navigation-link", {
                attrs: {
                  icon: "icon_fare-split",
                  label: "Partition",
                  to: {
                    name: "task-list/partition",
                    params: { clusterName: _vm.clusterName }
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "feature-flag",
            { attrs: { display: "inline", name: "taskListMetrics" } },
            [
              _c("navigation-link", {
                attrs: {
                  icon: "icon_chart",
                  label: "Metrics",
                  to: {
                    name: "task-list/metrics",
                    params: { clusterName: _vm.clusterName }
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "pollers",
          "date-format": _vm.dateFormat,
          domain: _vm.domain,
          "task-list": _vm.taskList,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "partition",
          domain: _vm.domain,
          "task-list": _vm.taskList
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "metrics",
          domain: _vm.domain,
          "task-list": _vm.taskList
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08ddd4ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ddd4ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/task-list/index.vue
// module id = 1735
// module chunks = 0